
const Config = require('config/js/lib/config.js');

const Q = require('q');
const $ = require('jquery');


module.exports = new Config(function () {
	return Q.Promise(function (resolve, reject) {
		$(function () {
			try {
				resolve(JSON.parse($('#cms-data-siteid').html()));
			} catch (e) {
				reject(e);
			}
		});
	});
});

